import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPIProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPI: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPIProps
> = props => {
  let component = props.component,
    range = props.range || {},
    name = component.name,
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="requirements.txt" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="delete" text={name + ' \u003D\u003D ' + unsafeVersion} />
        <ArtifactViewCodeDiffDisplay type="add" text={name + ' \u003D\u003D ' + safeVersion} />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="requirements.txt" />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay type="add" text={name + ' \u003D\u003D ' + safeVersion} />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerPyPI;
